<script lang="ts">
  import backgroundSrc from "../images/footer.webp";
  import logoSrc from "../images/logo.svg";
  import { footerLabels } from "../lang";
  import Social from "./Social.svelte";
</script>

<section class="Footer" style="--background: url('{backgroundSrc}')">
  <p class="Footer-text">{footerLabels.text}</p>
  <Social />
  <img src={logoSrc} alt={footerLabels.logoAlt} width="256" height="62" />
</section>

<style>
  .Footer {
    background: var(--color-blue) var(--background) center / cover;
    color: var(--color-white);
    display: grid;
    gap: var(--size-32);
    grid-template-rows: min-content 5rem min-content;
    padding-block: var(--size-32);
    padding-inline: var(--app-inline-space);
    place-items: start;
  }

  .Footer-text {
    font-size: var(--size-16);
    font-weight: 600;
  }
</style>
